<template>
  <div class="push-wrap">
    <el-dialog
      title="转化目标推送"
      :visible.sync="showDialog"
      width="716px"
      :close-on-click-modal="false"
      @open="initSelect"
    >
      <el-transfer
        filterable
        v-model="selectCountList"
        :data="countList"
        class="dialog-wrap"
      ></el-transfer>
      <span slot="footer" class="dialog-footer">
        <div class="footer-wrap">
          <div class="form-switch">
            <span class="lable-text">推送免联调：</span>
            <el-switch v-model="noCheck" active-color="#1890FF"> </el-switch>
          </div>
          <div class="btn-list">
            <el-button @click="showDialog = false">取 消</el-button>
            <el-button type="primary" @click="handlerTransfer">确 定</el-button>
          </div>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getAdCount, convertPush } from "@/api/property.js";
export default {
  data() {
    return {
      showDialog: false,
      noCheck: false,
      countList: [],
      selectCountList: [],
      transferData: {},
    };
  },
  methods: {
    initSelect() {
      getAdCount().then((res) => {
        if (res.code === "0000") {
          this.countList = res.advertiseInfos.map((item) => {
            item.key = item.advertiserId;
            item.label = item.advertiserName + "(" + item.advertiserId + ")";
            return item;
          });
        }
      });
    },
    handlerTransfer() {
      if (this.selectCountList.length === 0) {
        this.$message({
          message: "请至少选择一个账号",
          type: "warning",
        });
      } else {
        convertPush({
          targetAdvertiserIds: this.selectCountList.join(),
          convertId: this.transferData.convert_id,
          advertiserId: this.transferData.account_id,
        }).then((res) => {
          if (res.code === "0000") {
            this.showDialog = false;
            this.$message({
              message: "推送成功",
              type: "success",
            });
          }
        });
      }
    },
    showTransferModal(data) {
      this.selectCountList = [];
      this.showDialog = true;
      this.transferData = data;
    },
  },
};
</script>

<style lang="less" scoped>
.push-wrap {
  .footer-wrap {
    display: flex;
    align-items: center;
    .form-switch {
      margin-right: auto;
      .lable-text {
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
      }
    }
  }
}
</style>